import React, { useState } from "react"
import PropTypes from "prop-types"
import * as styles from "./TopNavAccordionItem-tw-styles"
import Button from "../../../../UI/Button/Button"
import Link from "../../../../UI/Link/Link"
import { gaMenuClick } from "../../../../../constants/gtm.constants"

const TopNavAccordionItem = ({ item, active, onToggle }) => {
  const style = styles["defaultStyle"]
  const [hasInnerChild, setHasInnerChild] = useState(false)
  const [toggleId, setToggleId] = useState([])
  const [hasSecondInnerChild, setHasSecondInnerChild] = useState(false)
  const [secondToggleId, setSecondToggleId] = useState([])

  const handleInnerAccordion = index => {
    if (toggleId.includes(index)) {
      if (!hasInnerChild) {
        setToggleId([...toggleId, index])
      }
      let toggleIdCopy = [...toggleId]
      let closeIndex = toggleIdCopy.indexOf(index)
      toggleIdCopy.splice(closeIndex, 1)
      setToggleId(toggleIdCopy)

      setHasInnerChild(!hasInnerChild)
    } else {
      setToggleId([...toggleId, index])
      setHasInnerChild(true)
    }
  }

  const handleSecondInnerAccordion = index => {
    if (secondToggleId.includes(index)) {
      if (!hasSecondInnerChild) {
        setSecondToggleId([...secondToggleId, index])
      }
      let secondToggleIdCopy = [...secondToggleId]
      let closeIndex = secondToggleIdCopy.indexOf(index)
      secondToggleIdCopy.splice(closeIndex, 1)
      setSecondToggleId(secondToggleIdCopy)

      setHasSecondInnerChild(!hasSecondInnerChild)
    } else {
      setSecondToggleId([...secondToggleId, index])
      setHasSecondInnerChild(true)
    }
  }

  return (
    <li
      className={
        active ? `${style?.mainMobilUlLI} ToggleOpened` : style?.mainMobilUlLI
      }
    >
      {item?.link ? (
        <Link {...item?.link} className={style?.mainMobilUlLIink} gaEventClass={gaMenuClick}
        gaEventLabel={item?.label}> 
          {item.label}
        </Link>
      ) : (
        <Button className={style?.mainMobilUlBtn} onClick={onToggle}>
          {item.label}

          <span
            className={active ? "accordianIconSub active" : "accordianIconSub"}
          ></span>
        </Button>
      )}

      <div
        className={
          active
            ? `${style?.mainMobilUlSUbmenu} darkSubTGOpen`
            : style?.mainMobilUlSUbmenu
        }
      >
        {/* First Level Accordion*/}
        {item?.dropdownItems?.map((item, index1) => {
          if (item?.dropdownItems?.length > 0) {
            return (
              <div
                key={index1}
                className={
                  active && toggleId.includes(index1)
                    ? `${style?.mainMobiSUbmenuDiv} scToggeldActive`
                    : `${style?.mainMobiSUbmenuDiv}`
                }
              >
                <div
                  onClick={() => handleInnerAccordion(index1)}
                  className={
                    toggleId.includes(index1)
                      ? `${style?.mainMobiSUbmenuSubIcon} active`
                      : style?.mainMobiSUbmenuSubIcon
                  }  data-testid = {`inneraccordionitem-${index1}`}
                >
                  {item.label}{" "}
                  <span
                    className={
                      toggleId.includes(index1)
                        ? "accordianIconSub active"
                        : "accordianIconSub"
                    }
                  ></span>
                </div>
                <div
                  className={
                    active && toggleId.includes(index1)
                      ? `${style?.mainMobiSUbmenuSubWrap} active`
                      : style?.mainMobiSUbmenuSubWrap
                  }
                >
                  <div className={style?.mainMobiSUbmSubWrapIn}>
                    {/* Second Level Accordion */}
                    {item?.dropdownItems?.map((item, index2) => {
                      if (item?.dropdownItems?.length > 0) {
                        return (
                          <div key={index2} className="CountryParent">
                            <div
                              onClick={() => handleSecondInnerAccordion(index2)}
                              className="CountryParentIn"
                              data-testid = {`innersecondaccordionitem-${index1}`}
                            >
                              {item.label}

                              <span
                                className={
                                  secondToggleId.includes(index2)
                                    ? "accordianIconSub active"
                                    : "accordianIconSub"
                                }
                              ></span>
                            </div>
                            {
                              <div
                                className={
                                  secondToggleId.includes(index2)
                                    ? "CountryParent-More active"
                                    : "CountryParent-More"
                                }
                              >
                                <div className="CountryParent-MoreIn">
                                  {/* Third Level Accordion */}
                                  {item?.dropdownItems?.map((item, index3) => {
                                    return (
                                      <Link {...item?.link} key={index3} gaEventClass={gaMenuClick}
                                      gaEventLabel={item?.label}>
                                        {item?.label}
                                      </Link>
                                    )
                                  })}
                                </div>
                              </div>
                            }
                          </div>
                        )
                      } else {
                        return (
                          <div key={index2}>
                            <Link {...item?.link} gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}>{item?.label}</Link>
                          </div>
                        )
                      }
                    })}
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div key={index1}>
                <Link {...item?.link} gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}>{item?.label}</Link>
              </div>
            )
          }
        })}
      </div>
    </li>
  )
}

TopNavAccordionItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.bool,
  onToggle: PropTypes.func,
}

export default TopNavAccordionItem
